webpackJsonp([16329218117415],{

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _config = __webpack_require__(13);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _PageTitle = __webpack_require__(27);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Venue = function Venue() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_PageTitle2.default, { title: 'Venue' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ceremony and reception will be held at',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: _config2.default.venue.webAddr },
	        _config2.default.venue.title
	      ),
	      ':'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _config2.default.venue.physicalAddr
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Directions to the venue can be found on',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: _config2.default.venue.googleMapsLink },
	        'Google Maps'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _config2.default.venue.drivingNotes
	    )
	  );
	};
	
	exports.default = Venue;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-venue-js-619d5a17c199e160fe6d.js